///<amd-module name="EventListenerHelper"/>

import { start, cancelTests, runIndividualTask } from "../SelfHelp";
import { downloadBlob } from "./BlobHelper";
import { showAllDetails, hideAllDetails, toggleAccordionDataDisplay } from "./DomHelper";

const global = window;
const { selfHelp: { useTelemetry }} = global;

/** Adds an event listener to the "run tasks" button which triggers the beginning of the diagnostics */
function addRunTasksListener(): void {
    const runTasksBtn = document.getElementById("shdid-run-tasks-btn");
    $(runTasksBtn).click((evt: Event) => {
        evt.preventDefault();
        start();
    });
}

/** Adds an event listener to the "cancel" button which cancels the execution of tests where they"re at */
function addCancelTestsListener(): void {
    const cancelTasksBtn = document.getElementById("shdid-cancel-tasks-btn");
    $(cancelTasksBtn).click((evt: Event) => {
        evt.preventDefault();
        cancelTests();
    });
}

/** Adds event listener so that accordion drops down when "Show Details" is clicked */
function addAccordionListener(): void {
    document.querySelectorAll(".shd-accordion-show-details").forEach((button) => {
        $(button).click(() => {
            const key = button.id.split("-")[1];
            toggleAccordionDataDisplay(key);
        });
    });
}

/** Adds event listener for when checkbox becomes checked / unchecked */
function addCheckboxListener(): void {
    const checkbox = document.getElementById("shdid-shd-show-details-checkbox");
    checkbox.addEventListener("change", function() {
        if($(this).is(":checked")) {
            showAllDetails();
        } else {
            hideAllDetails();
        }
    });
}

/** Adds event listener to individual "Run task" buttons */
function addRunTaskAgainListener(): void {
    document.querySelectorAll(".shd-run-tasks-again-btn").forEach((button) => {
        $(button).click((evt: Event) => {
            evt.preventDefault();
            const taskId = button.id.split("-")[1];
            runIndividualTask(taskId);
        });
    });
}

/**
 * Adds event listener to "Download Blob" button, calls function in Blob helper
 * so that download will not be blocked by browser
 */
function addBlobHelperListener(): void {
    const button = document.getElementById("shdid-download-blob-link");
    $(button).click((evt: Event) => {
        evt.preventDefault();
        downloadBlob();
    });
}

/** Adds event listener for telemetry feedback */
function feedbackHelpfulListener(): void {
    const button = document.getElementById("shdid-telemetry-yes");
    $(button).click((evt: Event) => {
        evt.preventDefault();
    });
}

/** Adds event listener for telemetry feedback */
function feedbackNotHelpfulListener(): void {
    const button = document.getElementById("shdid-telemetry-no");
    $(button).click((evt: Event) => {
        evt.preventDefault();
    });
}

/** Function triggers adding all the event listeners to the page */
export function addListeners(): void {
    addRunTasksListener();
    addCancelTestsListener();
    addAccordionListener();
    addCheckboxListener();
    addRunTaskAgainListener();
    addBlobHelperListener();
    if (useTelemetry) {
        feedbackHelpfulListener();
        feedbackNotHelpfulListener();
    }
}
